import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { NavContext } from '../../contexts/nav-context'

interface NavProps {
	bgColor?: string
	navColor?: string
	onClickNavIcon: () => void
}

const Navbar: React.FC<NavProps> = ({ bgColor, navColor, onClickNavIcon }) => {
	const { isNavMenuOpen, hideNavMenu } = useContext(NavContext)

	useEffect(() => {
		let navIcon = Array.from(document.querySelectorAll('.nav-icon > *'))

		if (window.location.pathname === '/gallery') {
			if (isNavMenuOpen) {
				navIcon.forEach((icon) => icon.setAttribute('style', 'background-color: #000000;'))
			} else {
				navIcon.forEach((icon) => icon.setAttribute('style', 'background-color: #ffffff;'))
			}
		}
	}, [isNavMenuOpen])

	return (
		<div className='nav-bar--container'>
			<Link to='/'>
				<div className='nav-bar--image-logo' onClick={hideNavMenu}>
					<div className='nav-bar--image-logo__img-one'>
						<img src='/images/navbar-1.png' alt='' />
						<span></span>
					</div>
					<div className='nav-bar--image-logo__img-two'>
						<img src='/images/navbar-2.png' alt='' />
						<span></span>
					</div>
				</div>
			</Link>

			<Link to='/'>
				<img className='nav-50-logo' src='/images/mummy-at-50-logo.png' alt='' />
			</Link>

			<div className='nav-icon' onClick={onClickNavIcon}>
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
	)
}

export default Navbar
